<div class="app-page-container">
  <div *ngIf="header" class="app-page-container-header p-d-flex p-ai-center">
    <a pButton *ngIf="backButtonLink"
      [routerLink]="backButtonLink"
      class="p-button-rounded p-button-secondary p-mr-2"
      icon="pi pi-angle-left"
      title="Back">
    </a>
    <h1>{{header}}</h1>
  </div>
  <div class="app-page-container-content">
    <ng-content></ng-content>
  </div>
</div>
